'use client';

// Utils
import { combineClasses, getCurrentYear } from '@shared/utils';

// Hooks
import { useChatbotSidebarVisibility } from '@/hooks/useChatbotSidebarVisibility';

// Icons
import { HeartIcon } from '@shared/icons/HeartIcon';
interface FooterProps {
  className?: string;
}
export const Footer = ({
  className
}: FooterProps) => {
  const isSidebarOpen = useChatbotSidebarVisibility();
  return <footer className={combineClasses('w-full py-5.75 px-7.5 bg-primary md:relative min-h-17.5', 'flex items-center justify-center lg:justify-between', className)} data-sentry-component="Footer" data-sentry-source-file="index.tsx">
      {!isSidebarOpen && <p className={combineClasses('min-w-copyright-footer flex md:absolute', 'text-2xs font-semibold text-white text-left')}>
          &#169; AgilityIO {getCurrentYear()}
        </p>}

      <div className={combineClasses('hidden flex-center w-full gap-2 lg:flex max-h-17.5')}>
        <p className="text-4xs xs:text-2xs text-white font-semibold text-center">
          made in <span className="text-xs xs:text-sm uppercase">Da Nang</span>{' '}
          with
        </p>
        <HeartIcon className="text-secondary" data-sentry-element="HeartIcon" data-sentry-source-file="index.tsx" />
      </div>
    </footer>;
};